//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import rule from './item-rule.vue';
import edit from './edit.vue';
import { GetRule, DeleteRule } from '@/api/audit';
export default {
  components: { rule, edit },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 规则
      oldRule: [],
      rule: [
        [
          {
            type: '',
            operator: '',
            val: '',
          },
        ],
      ],
      // 编辑
      editRuleInfo: {
        id: '',
        ruler: [
          {
            type: '',
            operator: '',
            val: '',
          },
        ],
      },
      showEdit: false,
    };
  },
  computed: {
    showRule: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) {
          this.$emit('cancel');
        }
      },
    },
  },
  created() {
    this.GetRule();
  },
  methods: {
    async GetRule() {
      this.showEdit = false;
      const { audit_rule: rule } = await GetRule();
      this.oldRule = rule.map((item) => {
        return {
          ...item,
          ruler: item.ruler.split('&&').map((rule) => {
            const xxx = rule.split('_');
            return {
              type: xxx[1],
              operator: xxx[2].split('(')[0],
              val: xxx[2].match(/("(\S*)")/)[2] || '',
            };
          }),
        };
      });
      this.rule =
        this.oldRule.length > 0
          ? this.oldRule
          : [
              [
                {
                  type: '',
                  operator: '',
                  val: '',
                },
              ],
            ];
    },
    editRule(info) {
      this.editRuleInfo = info || {
        id: '',
        ruler: [
          {
            type: '',
            operator: '',
            val: '',
          },
        ],
      };
      this.$nextTick(() => {
        this.showEdit = true;
      });
    },
    async delRule(index) {
      try {
        await this.$confirm('此操作将删除整条规则, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        const { id } = this.rule[index];
        await DeleteRule({ id });
        this.GetRule();
      } catch (err) {
        console.log(err);
      }
    },
  },
};
